import qs from 'qs'
import BVLoader from './../components/loader'
import WPCOMLogo from './../components/wpcom/wpcomlogo'

export const STATUS = { INITIALIZING: 6, RUNNING: 0, COMPLETED: 1, CANCELLED: 2, FAILED: 3, VALIDATING: 4, VALFAILED: 5 };

export const httpauth_src_fields = ['httpauth_src_user', 'httpauth_src_password',];
export const httpauth_dest_fields = ['httpauth_dest_user', 'httpauth_dest_password'];

export function humanReadableByteCount(bytes) {
	var unit = 1024;
	if (bytes < unit)
		return bytes + " Bytes";
	var exp = Math.floor((Math.log(bytes) / Math.log(unit)));
	var order = " " + "KMGTPE".charAt(exp - 1) + "B";
	return (bytes / Math.pow(unit, exp)).toFixed(2) + order;
};

export const PROTOCOL = {
	UNKNOWN : 0,
	FTP     : 1,
	FTPS    : 2,
	SFTP    : 3,
	CPANEL  : 4,
	TOKEN   : 5,
	HTTP    : 6
};

export const HOSTS = {
	UNKNOWN: "Unknown",
	WPENGINE: "WP Engine",
	PANTHEON: "Pantheon",
	SAVVII: "Savvii",
	CLOUDWAYS: "Cloudways",
	SITEGROUND: "Siteground",
	HOSTGATOR: "HostGator",
	FLYWHEEL: "Flywheel",
	GODADDY: "GoDaddy",
	PRESSABLE: "Pressable",
	WPSERVEUR: "WP Serveur",
	LIQUIDWEB: "Liquid Web",
	BLUEHOST: "Bluehost",
	WEFOSTER: "WeFoster",
	HOSTINGER: "Hostinger",
	GURUCOUK: "Guru UK",
	INTERSERVER: "InterServer",
	JAGUARPC: "JaguarPC",
	DREAMHOST: "DreamHost",
	INMOTION: "InMotion Hosting",
	A2HOSTING: "A2 Hosting",
	SANDBOX: "Sandbox",
	GENERIC: "Generic",
	CPANEL: "CPanel",
	PAGELY: "Pagely",
	NEXCESS: "Nexcess",
	KINSTA: "Kinsta",
	ELEMENTOR: "Elementor",
	AUTOMATTIC: "WordPress.com"
}

export const ONLY_FTP_HOSTS = [ ORIGIN.PANTHEON, ORIGIN.WPSERVEUR, ORIGIN.PRESSABLE, ORIGIN.SAVVII ]

export function getHostKey(host) {
	return _.findKey(HOSTS, value => value == host).toLowerCase()
}

export function cancelModalCSSClasses(migrate) {
	switch (migrate && migrate.get('origin')) {
	case ORIGIN.CLOUDWAYS:
		return {main: 'cws', primaryButton: 'green-button border-none', secondaryButton: 'white-button ml-2'}
	case ORIGIN.WPENGINE:
		return {main: 'wpe', primaryButton: 'button migrate-button width33 mt-2', secondaryButton: 'button cancel-button mt-2'}
	default:
		return {}
	}
}

export function cancelModalTexts(migrate) {
	switch (migrate && migrate.get('origin')) {
	case ORIGIN.AUTOMATTIC:
		return {
			title: "Cancel migration",
			message: <span>If you cancel now, your site won't be migrated to WordPress.com.<br/>Are you sure you want to cancel?</span>,
			primaryBtnText: "Yes, cancel the migration",
			secondaryBtnText: "No, continue migrating"
		}
	default:
		return {
			title: "Cancel Confirmation",
			message: "Are you sure, you want to cancel this migration?",
			primaryBtnText: "Yes, cancel it",
			secondaryBtnText: "No, go back"
		}
	}
}

export function getLocationQuery(history) {
	const { location } = history
	return qs.parse(location.search, {ignoreQueryPrefix: true})
}

export function stripProtocol(url) {
	return url.replace(/(^\w+:|^)\/\//, '');
}

export function getLoader () {
	if (window.migrate_origin === ORIGIN.AUTOMATTIC) {
		return <WPCOMLogo klass="wpcom-site-logo-loading"/>
	} else {
		return <BVLoader/>
	}
}
